module.exports = __webpack_public_path__ + "static/N2N5s-6c8674c4423981f176d7080cc6c3a2f8.jpg";